module.exports = __webpack_public_path__ + "static/aragon-videomock-medium-0b6a4f4a804fd474dd208aa2c6453e54.mp4";